function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { INITIATE_BULK_UPLOAD_FILES_FAILURE, INITIATE_BULK_UPLOAD_FILES_REQUEST } from "../../../actions/types";
import { initiateBulkUploadFilesAction, filePartsUploadAction } from "../../../actions";
import { CHUNKS_SIZE } from "../../../constants/upload";
import { addNotification } from "../../../actions/ui";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, NotificationTypeEnum } from "../../../actions/ui/types";
import { reportsCenterErrorCodes } from "../../../config/errorCodeMessages";
export var initiateBulkUploadFilesEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(INITIATE_BULK_UPLOAD_FILES_REQUEST), switchMap(function(param) {
        var payload = param.payload;
        var initiateBatchReportUploadInput = payload.initiateBatchReportUploadInput, files = payload.files;
        return from(api.reportsCenterService.initiateBatchReportUpload(initiateBatchReportUploadInput).pipe(mergeMap(function(initiateBatchReportUploadOutput) {
            var _ref = initiateBatchReportUploadOutput || {}, initiateUploadResponseList = _ref.InitiateUploadResponseList;
            var parallelPartsUploadObservables = initiateUploadResponseList.map(function(initiateUploadResponse, index) {
                var requiredFile = files[index];
                var partUploadRequests = [];
                var sentSize = 0;
                if (requiredFile) {
                    initiateUploadResponse.partPresignedURLs.forEach(function(partPresignedURL, index) {
                        sentSize = index * CHUNKS_SIZE;
                        partUploadRequests.push(api.reportsCenterService.uploadWithS3PresignedUrl({
                            file: requiredFile.slice(sentSize, sentSize + CHUNKS_SIZE),
                            s3presignedUrl: partPresignedURL
                        }));
                    });
                }
                return {
                    partUploadRequests: partUploadRequests,
                    uploadId: initiateUploadResponse.uploadId,
                    reportId: initiateUploadResponse === null || initiateUploadResponse === void 0 ? void 0 : initiateUploadResponse.reportId,
                    partPresignedURLs: initiateUploadResponse.partPresignedURLs,
                    key: initiateBatchReportUploadInput.InitiateUploadRequestList[index].key,
                    supportingDocumentInfo: initiateBatchReportUploadInput.InitiateUploadRequestList[index].supportingDocumentInfo,
                    logisticsPartyId: initiateBatchReportUploadInput.logisticsPartyId,
                    reportType: initiateBatchReportUploadInput.reportType,
                    term: initiateBatchReportUploadInput.term
                };
            });
            var filePartsUploadActions = parallelPartsUploadObservables.map(function(parallelPartsUploadObservable) {
                return filePartsUploadAction.request(parallelPartsUploadObservable);
            });
            return of.apply(void 0, [
                initiateBulkUploadFilesAction.success({
                    initiateBatchReportUploadOutput: initiateBatchReportUploadOutput
                })
            ].concat(_to_consumable_array(filePartsUploadActions)));
        }), catchError(function(err) {
            var _err_receivedException, _err_receivedException1;
            var _reportsCenterErrorCodes_err_receivedException_errorCode;
            return of(initiateBulkUploadFilesAction.failure(err), addNotification({
                type: NotificationTypeEnum.ERROR,
                action: INITIATE_BULK_UPLOAD_FILES_FAILURE,
                body: (err === null || err === void 0 ? void 0 : (_err_receivedException = err.receivedException) === null || _err_receivedException === void 0 ? void 0 : _err_receivedException.errorCode) ? (_reportsCenterErrorCodes_err_receivedException_errorCode = reportsCenterErrorCodes[err === null || err === void 0 ? void 0 : (_err_receivedException1 = err.receivedException) === null || _err_receivedException1 === void 0 ? void 0 : _err_receivedException1.errorCode]) !== null && _reportsCenterErrorCodes_err_receivedException_errorCode !== void 0 ? _reportsCenterErrorCodes_err_receivedException_errorCode : "initiate_upload_files_notifications.failure" : "initiate_upload_files_notifications.failure",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
        })));
    }));
};
export default initiateBulkUploadFilesEpic;

//# sourceMappingURL=index.js.map